import React from "react";
import { FormattedMessage } from "react-intl";
import messages from "./messages";

const FeedWelcome = () => (
  <div className="afd-story--welcome">
    <h3 className="afd-title-big afd-title-big--bmargin-small afd-container-padding--m afd-title--center">
      <FormattedMessage {...messages.welcomeTitle} />
    </h3>
    <div className="afd-story--body afd-post-content">
      <p><FormattedMessage {...messages.welcomeParagraph} /></p>
    </div>
  </div>
);

export default FeedWelcome;
